export const ALLOWED_TAGS: string[] = ["a", "b", "blockquote", "br", "caption", "code", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6",
    "p", "i", "iframe", "img", "li", "ol", "p", "pre", "s", "span", "strike", "strong", "table", "tbody", "td", "th",
    "thead", "tr", "u", "ul"];
